// @ts-nocheck
export const FREE_COURSES_AMPLITUDE_PAGE_NAME = 'Free Courses';
export const FREE_COURSES_PAGE_KEY = 'free-courses';
export const initialStatePageKey = 'crehanaApp';
export const prefixClass = 'rwl';

const url = 'https://www.crehana.com/trabajo-remoto/';

export const shareLinks = {
  LINKEDIN: `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
  FACEBOOK: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  TWITTER: `https://twitter.com/share?url=${url}`,
};
